import { FormBuilderType, FormBuilderValidator } from "@grassrootly/rn-core";

export interface IAddPlayerForm {
  email?: string;
  name: string;
}
export const addPlayerForm: FormBuilderType<IAddPlayerForm> = {
  name: {
    type: "input",
    name: "name",
    label: "Full Name",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.minChar(3)],
    required: true,
    props: {
      keyboardType: "name-phone-pad",
    },
  },
  email: {
    type: "input",
    name: "email",
    label: "Email (Optional)",
    defaultValue: "",
    validators: [FormBuilderValidator.email()],
    required: false,
    props: {
      keyboardType: "email-address",
    },
  },
};
